import React from "react";
import SelectInputField from "./SelectInputField";
import {
  Flex,
  InputLeftElement,
  InputGroup,
  Input,
  Button,
} from "@chakra-ui/react";
import { BiSearch } from "react-icons/bi";
import moment from "moment";
import { useState } from "react";
import CustomFilterModal from "../Modals/CustomFilterModal";

function FilterComponent({ filters, setFilters, statusData, downloadHandler }) {
  const [openCustom, setOpenCustom] = useState(false);
  const handleDateFilterChange = async (value) => {
    switch (value) {
      case "today":
        setFilters({
          ...filters,
          from: moment().format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "yesterday":
        setFilters({
          ...filters,
          from: moment().subtract(1, "days").format("YYYY-MM-DD"),
          to: moment().subtract(1, "days").format("YYYY-MM-DD"),
        });
        break;
      case "7-days":
        setFilters({
          ...filters,
          from: moment().subtract(6, "days").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "1-month":
        setFilters({
          ...filters,
          from: moment().subtract(1, "months").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "3-months":
        setFilters({
          ...filters,
          from: moment().subtract(3, "months").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "6-months":
        setFilters({
          ...filters,
          from: moment().subtract(6, "months").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "9-months":
        setFilters({
          ...filters,
          from: moment().subtract(9, "months").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "1-year":
        setFilters({
          ...filters,
          from: moment().subtract(1, "years").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        });
        break;
      case "custom":
        setOpenCustom(true);
        break;
      default:
        break;
    }

    // await getUserTransactionList();
  };
  return (
    <Flex
      columns={[2, 2, 4, 4]}
      justify="space-between"
      mt="10px"
      p={["25px 10px", "25px 15px", "25px"]}
      bg="#FFFFFF"
      spacing="20px"
      maxWidth="100%"
    >
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <BiSearch size="20px" color="#666666" />
        </InputLeftElement>
        <Input
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              setFilters({ ...filters, searchQuery: e.target.value });
            }
          }}
          border="1px solid #E4E8F2"
          fontSize="13px"
          fontFamily="satoshiBold"
          color="#666666"
          type="tel"
          placeholder="Search name or enter keyword"
        />
      </InputGroup>

      <SelectInputField
        onChange={handleDateFilterChange}
        data={[
          { name: "Today", value: "today" },
          { name: "Yesterday", value: "yesterday" },
          { name: " 7 Days", value: "7-days" },
          { name: "1 Month", value: "1-month" },
          { name: "3 Months", value: "3-months" },
          { name: "6 Months", value: "6-months" },
          { name: "9 Months", value: "9-months" },
          { name: "1 Year", value: "1-year" },
          { name: "Custom", value: "custom" },
        ]}
      />

      {statusData && (
        <SelectInputField
          onChange={(value) => setFilters({ ...filters, status: value })}
          data={statusData}
        />
      )}

      <Button
        onClick={downloadHandler}
        bg="#5B2E4F"
        color="white"
        fontSize="12px"
        fontWeight="500"
        p="0 30px"
        marginX="4"
      >
        EXPORT
      </Button>

      <CustomFilterModal
        open={openCustom}
        setOpen={setOpenCustom}
        filters={filters}
        setFilters={setFilters}
      />
    </Flex>
  );
}

export default FilterComponent;
